import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../wayfinder'
/**
* @see \App\Http\Controllers\SpectreLinkController::__invoke
* @see app/Http/Controllers/SpectreLinkController.php:39
* @route '//spectre.link/{linkGroup}'
*/
export const spectreLink = (args: { linkGroup: string | { slug: string } } | [linkGroup: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: spectreLink.url(args, options),
    method: 'get',
})

spectreLink.definition = {
    methods: ["get","head"],
    url: '//spectre.link/{linkGroup}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SpectreLinkController::__invoke
* @see app/Http/Controllers/SpectreLinkController.php:39
* @route '//spectre.link/{linkGroup}'
*/
spectreLink.url = (args: { linkGroup: string | { slug: string } } | [linkGroup: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { linkGroup: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { linkGroup: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            linkGroup: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        linkGroup: typeof args.linkGroup === 'object'
        ? args.linkGroup.slug
        : args.linkGroup,
    }

    return spectreLink.definition.url
            .replace('{linkGroup}', parsedArgs.linkGroup.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SpectreLinkController::__invoke
* @see app/Http/Controllers/SpectreLinkController.php:39
* @route '//spectre.link/{linkGroup}'
*/
spectreLink.get = (args: { linkGroup: string | { slug: string } } | [linkGroup: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: spectreLink.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SpectreLinkController::__invoke
* @see app/Http/Controllers/SpectreLinkController.php:39
* @route '//spectre.link/{linkGroup}'
*/
spectreLink.head = (args: { linkGroup: string | { slug: string } } | [linkGroup: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: spectreLink.url(args, options),
    method: 'head',
})

/**
* @see \AgentSoftware\LaravelSocialiteSpectreId\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/agentsoftware/laravel-socialite-spectre-id/src/Http/Controllers/AuthenticatedSessionController.php:35
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \AgentSoftware\LaravelSocialiteSpectreId\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/agentsoftware/laravel-socialite-spectre-id/src/Http/Controllers/AuthenticatedSessionController.php:35
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \AgentSoftware\LaravelSocialiteSpectreId\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/agentsoftware/laravel-socialite-spectre-id/src/Http/Controllers/AuthenticatedSessionController.php:35
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \AgentSoftware\LaravelSocialiteSpectreId\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/agentsoftware/laravel-socialite-spectre-id/src/Http/Controllers/AuthenticatedSessionController.php:35
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \AgentSoftware\LaravelSocialiteSpectreId\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/agentsoftware/laravel-socialite-spectre-id/src/Http/Controllers/AuthenticatedSessionController.php:118
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: logout.url(options),
    method: 'get',
})

logout.definition = {
    methods: ["get","post","head"],
    url: '/logout',
} satisfies RouteDefinition<["get","post","head"]>

/**
* @see \AgentSoftware\LaravelSocialiteSpectreId\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/agentsoftware/laravel-socialite-spectre-id/src/Http/Controllers/AuthenticatedSessionController.php:118
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \AgentSoftware\LaravelSocialiteSpectreId\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/agentsoftware/laravel-socialite-spectre-id/src/Http/Controllers/AuthenticatedSessionController.php:118
* @route '/logout'
*/
logout.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: logout.url(options),
    method: 'get',
})

/**
* @see \AgentSoftware\LaravelSocialiteSpectreId\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/agentsoftware/laravel-socialite-spectre-id/src/Http/Controllers/AuthenticatedSessionController.php:118
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \AgentSoftware\LaravelSocialiteSpectreId\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/agentsoftware/laravel-socialite-spectre-id/src/Http/Controllers/AuthenticatedSessionController.php:118
* @route '/logout'
*/
logout.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: logout.url(options),
    method: 'head',
})

/**
* @see vendor/agentsoftware/laravel-socialite-spectre-id/routes/boot-watchdog.php:10
* @route '/boot-error'
*/
export const bootError = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bootError.url(options),
    method: 'post',
})

bootError.definition = {
    methods: ["post"],
    url: '/boot-error',
} satisfies RouteDefinition<["post"]>

/**
* @see vendor/agentsoftware/laravel-socialite-spectre-id/routes/boot-watchdog.php:10
* @route '/boot-error'
*/
bootError.url = (options?: RouteQueryOptions) => {
    return bootError.definition.url + queryParams(options)
}

/**
* @see vendor/agentsoftware/laravel-socialite-spectre-id/routes/boot-watchdog.php:10
* @route '/boot-error'
*/
bootError.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bootError.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\DashboardController::__invoke
* @see app/Http/Controllers/DashboardController.php:53
* @route '/dashboard'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/dashboard',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\DashboardController::__invoke
* @see app/Http/Controllers/DashboardController.php:53
* @route '/dashboard'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\DashboardController::__invoke
* @see app/Http/Controllers/DashboardController.php:53
* @route '/dashboard'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DashboardController::__invoke
* @see app/Http/Controllers/DashboardController.php:53
* @route '/dashboard'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\RequestProductAccessController::__invoke
* @see app/Http/Controllers/RequestProductAccessController.php:21
* @route '/request-product-access'
*/
export const requestProductAccess = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: requestProductAccess.url(options),
    method: 'post',
})

requestProductAccess.definition = {
    methods: ["post"],
    url: '/request-product-access',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\RequestProductAccessController::__invoke
* @see app/Http/Controllers/RequestProductAccessController.php:21
* @route '/request-product-access'
*/
requestProductAccess.url = (options?: RouteQueryOptions) => {
    return requestProductAccess.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\RequestProductAccessController::__invoke
* @see app/Http/Controllers/RequestProductAccessController.php:21
* @route '/request-product-access'
*/
requestProductAccess.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: requestProductAccess.url(options),
    method: 'post',
})

